import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import { DatePicker } from 'antd';
import dayjs from "dayjs";
import { connect } from "react-redux";
import IAppState from "../../redux/types/IAppState";


const DatePickerFormikField =  ({ ...props }: { [x: string]: any; name: string }) => {
  const EUROPEAN_DATE_FORMAT = "DD/MM/YYYY";
  const preferenceDateFormat = props.customerDatePreference ? props.customerDatePreference : EUROPEAN_DATE_FORMAT;
  const [field, meta, { setValue }] = useField(props);
  const { isSubmitting } = useFormikContext();

  const [panelDate, setPanelDate] = useState(() => field.value ? dayjs(field.value) : dayjs());

  return (
    <div
      data-testid={props.name}
      className={
        isSubmitting && (meta.error || props.error)
          ? "validationForkmikField"
          : "emptyValidationBorder"
      }
    >
      <DatePicker
       size={props.size ? props.size : 'medium'}
       style={{width: '100%', borderRadius: '3px'}}
        format={preferenceDateFormat}
        {...props}
        value={field.value ? dayjs(field.value) : null}        
        onChange={(val) => {
          props.onChange && props.onChange();
          setValue(val ? val.format('YYYY-MM-DD') : '');
          setPanelDate(val || dayjs());
        }}
        onPanelChange={(val) => {
          setPanelDate(val);
        }}
        defaultPickerValue={panelDate}
        placeholder={props.placeholder}
      />
    </div>
  );
};

export default connect((state: IAppState) => {
    return ({
        customerDatePreference: state.account.customerDate,
        customerTimeZonePreference: state.account.customerTimeZone
    })
})(DatePickerFormikField);